import React, { useState } from "react";
import { SectionLabel, Reveal, CTAButton } from "@/lib/uiHelpers";
import { FAQS } from "@/constants/landingCopy";
import { Plus, Minus } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

function Item({ faq, isOpen, onToggle, index }) {
  return (
    <div className="rounded-xl bg-white overflow-hidden" style={{ border: "1px solid #ece7dc" }}>
      <button
        type="button"
        data-testid={`faq-toggle-${index}`}
        onClick={onToggle}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-5"
      >
        <span className="font-head font-bold text-base md:text-lg" style={{ color: "#1A2B4A" }}>
          {faq.q}
        </span>
        <span
          className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full"
          style={{ background: isOpen ? "#F5A623" : "#F4F0E8", color: "#1A2B4A" }}
        >
          {isOpen ? <Minus size={16} /> : <Plus size={16} />}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <p className="font-body px-5 md:px-6 pb-5 text-[#2C3E50]/85 text-sm md:text-base">
              {faq.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="section-pad" style={{ backgroundColor: "#F4F0E8" }}>
      <div className="container-max">
        <Reveal className="text-center max-w-2xl mx-auto">
          <SectionLabel>Common Questions</SectionLabel>
          <h2 className="font-head font-extrabold text-3xl md:text-5xl" style={{ color: "#1A2B4A" }}>
            Answers Before You Ask
          </h2>
        </Reveal>

        <div className="mt-10 max-w-3xl mx-auto space-y-3">
          {FAQS.map((faq, i) => (
            <Reveal key={faq.q} delay={Math.min(i * 0.04, 0.2)}>
              <Item faq={faq} index={i} isOpen={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
            </Reveal>
          ))}
        </div>

        <div className="mt-10 text-center">
          <CTAButton testId="faq-cta" variant="gold" className="w-full sm:w-auto">
            &rarr; Book My Free Discovery Call
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
